// extracted by mini-css-extract-plugin
export default {"root":"ClassCreationTrackerRow_root__y19l4"};